import StreetAddress from './StreetAddress';

import type { StreetAddressProps } from './StreetAddress';

const ClaimListing = ({
  listingAlias = '',
  feedName = '',
  address = {},
  photoUrl = '',
  isActive = null,
  status = '',
  contactEmail = '',
  contactPhone = '',
}: {
  listingAlias?: string;
  feedName?: string;
  address?: StreetAddressProps;
  photoUrl?: string;
  isActive?: boolean | null;
  status?: string;
  contactEmail?: string;
  contactPhone?: string;
} = {}) => ({
  listingAlias: String(listingAlias),
  feedName: String(feedName),
  address: StreetAddress(address),
  photoUrl: String(photoUrl),
  isActive: Boolean(isActive),
  status: String(status),
  contactEmail: String(contactEmail),
  contactPhone: String(contactPhone),
});

export default ClaimListing;

export type ClaimListingProps = ReturnType<typeof ClaimListing>;
